import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import RegularizationForm from "./RegularizationForm";
import RegularizationList from "./RegularizationList";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { CalendarDays } from "lucide-react";

const AttendanceRegularization = () => {
  const user = useSelector((state) => state.user.user);
  const [activeTab, setActiveTab] = useState("apply");
  const [hasReportees, setHasReportees] = useState(false);

  // Check if user is Owner or has reportees
  useEffect(() => {
    const checkPermission = async () => {
      try {
        const res = await api.get(SummaryApi.teamTdyAttendanceStatus.url);
        if (res.data.success) {
          const isOwner = user?.role === 'owner';
          const hasDirectReportees = res.data.data.reportees?.length > 0;
          setHasReportees(isOwner || hasDirectReportees);
        }
      } catch (err) { 
        console.error(err); 
      }
    };
    checkPermission();
  }, [user]);

  return (
    <div className="">
      {/* Header & Tabs Container */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 p-5 rounded-lg">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-red-50 text-red-600 rounded-xl">
            <CalendarDays size={24} />
          </div>
          <div>
            <h1 className="text-lg sm:text-xl font-extrabold text-gray-900 uppercase tracking-tight">
              Attendance Regularization
            </h1>
            <p className="text-xs text-gray-500 mt-0.5">Manage and correct your attendance records easily.</p>
          </div>
        </div>
        
        {/* Responsive Tabs (No breaking, smooth horizontal scroll on mobile) */}
        <div className="w-full lg:w-auto overflow-x-auto no-scrollbar -mx-5 px-5 lg:mx-0 lg:px-0">
          <div className="flex bg-white p-2 rounded-xl min-w-max gap-1">
            <button 
              onClick={() => setActiveTab("apply")} 
              className={`px-5 py-2.5 rounded-lg text-xs font-bold uppercase transition-all duration-200 ${
                activeTab === "apply" 
                  ? "bg-red-600 text-white shadow-md" 
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-300 hover:shadow-md"
              }`}
            >
              Apply
            </button>
            <button 
              onClick={() => setActiveTab("my")} 
              className={`px-5 py-2.5 rounded-lg text-xs font-bold uppercase transition-all duration-200 ${
                activeTab === "my" 
                  ? "bg-red-600 text-white shadow-sm" 
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-300"
              }`}
            >
              My Requests
            </button>
            
            {hasReportees && (
              <button 
                onClick={() => setActiveTab("team")} 
                className={`px-5 py-2.5 rounded-lg text-xs font-bold uppercase transition-all duration-200 ${
                  activeTab === "team" 
                    ? "bg-red-600 text-white shadow-sm" 
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-300"
                }`}
              >
                Team Requests
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="mt-6 transition-all duration-300">
        {activeTab === "apply" && <RegularizationForm onSuccess={() => setActiveTab("my")} />}
        {activeTab === "my" && <RegularizationList type="my" />}
        {activeTab === "team" && <RegularizationList type="team" />}
      </div>
    </div>
  );
};

export default AttendanceRegularization;